import React, { PureComponent, ReactNode } from 'react'
import { majorScale, defaultTheme, Pane, SubtleFills, IconName } from 'evergreen-ui'

interface CircleIconWrapperProps {
  background?: string
  color?: keyof SubtleFills
  icon: IconName | ReactNode
  size?: number
}

/**
 * Colored icon orb used in some blank states.
 */
export default class CircleIconWrapper extends PureComponent<
  CircleIconWrapperProps & React.ComponentProps<typeof Pane>
> {
  static defaultProps = {
    size: majorScale(8),
    background: 'greenTint'
  }

  render() {
    const { background, color, size, icon, ...props } = this.props

    let backgroundColor = background
    let iconColor = defaultTheme.palette.green.base

    if (color) {
      const colors = defaultTheme.getAvatarProps({ color })
      backgroundColor = colors.backgroundColor
      iconColor = colors.color
    }

    return (
      <Pane
        is="figure"
        aria-hidden
        borderRadius="50%"
        width={size}
        height={size}
        display="flex"
        alignItems="center"
        justifyContent="center"
        background={backgroundColor}
        color={iconColor}
        {...props}
      >
        {icon}
      </Pane>
    )
  }
}
